var _style, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: 100,
    height: 100,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n    .mountain { fill: #2c3e50; }\n    .rope { stroke: #ecf0f1; stroke-width: 2; fill: none; }\n    .climber { stroke: #3498db; stroke-width: 2; fill: none; }\n  ")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "mountain",
    d: "M10 90 L30 30 L50 90 L70 30 L90 90 Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "rope",
    d: "M50 30 L50 70"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "climber",
    d: "M50 50 L45 60 L55 60 L50 50 M50 60 L50 70 M45 65 L50 60 L55 65"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.be1877587726be1e8829aae7d4a97225.svg";
export { ForwardRef as ReactComponent };